class SidebarDrawer extends HTMLElement {
  constructor() {
    super();
    this.closeButton = null;
  }

  connectedCallback() {
    // Trova il bottone di chiusura all'interno del componente
    this.closeButtons = this.querySelectorAll('.cart-drawer-close') || [];

    // Aggiungi un listener per il click sul bottone di chiusura
    if (this.closeButtons.length > 0) {
      this.closeButtons.forEach(button => {
        button.addEventListener('click', () => this.close());
      });
    }
  }

  disconnectedCallback() {
    // Rimuovi l'event listener quando l'elemento viene rimosso dal DOM
    if (this.closeButtons) {
      this.closeButtons.forEach(button => {
        button.removeEventListener('click', () => this.close());
      });
    }
  }

  open() {
    // Aggiungi la classe "visible"
    this.classList.add('opened');
  }

  close() {
    // Rimuovi la classe "visible"
    this.classList.remove('opened');
  }
}
customElements.define('sidebar-drawer', SidebarDrawer);